import { useCallback, useState } from 'react';

const useModal = () => {
  const [isShowing, setIsShowing] = useState(false);

  const toggle = useCallback(() => {
    setIsShowing((showing) => !showing);
  }, []);

  const hide = useCallback(() => {
    setIsShowing(false);
  }, []);

  const show = useCallback(() => {
    setIsShowing(true);
  }, []);

  return {
    isShowing,
    toggle,
    show,
    hide,
  };
};

export default useModal;
